import * as actions from './descarte.action';
import inicialState from './descarte.state';

const descarteCommonReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.DESCARTE_COMMON_ATUALIZA_PERMISSAO_DESCARTE_MATERIAL:
      return {
        ...state,
        permissaoDescarteMateriais: action.payload.permissaoDescarteMateriais,
      };
    case actions.DESCARTE_COMMON_ATUALIZA_CONSULTA_DESCARTE_MATERIAL:
      return {
        ...state,
        permissaoConsultaDescarteMateriais: action.payload.permissaoConsultaDescarteMateriais,
      };
    case actions.DESCARTE_COMMON_ATUALIZA_TAB:
      return {
        ...state,
        tab: action.payload.tab,
      };

    case actions.DESCARTE_COMMON_TOTAL_MATERIAIS_A_VENCER:
      return {
        ...state,
        totalMateriaisavencer: action.payload.totalMateriaisavencer,
      };

      case actions.DESCARTE_COMMON_ATUALIZAR_DATAINI:
        return {
          ...state,
          dataInicio: action.payload.dataInicio,
        };

      case actions.DESCARTE_COMMON_ATUALIZAR_DATAFIM:
        return {
          ...state,
          dataFim: action.payload.dataFim,
        };
   
      case actions.DESCARTE_COMMON_ATUALIZAR_FILTRO_VALUE:
        return {
          ...state,
          filtroValue: action.payload.filtroValue,
        };

    case actions.DESCARTE_COMMON_ATUALIZA_MOTIVO:
      return {
        ...state,
        motivo: action.payload.motivo,
      };

    case actions.DESCARTE_COMMON_ATUALIZA_PESO:
      return {
        ...state,
        peso: action.payload.peso,
      };
    case actions.DESCARTE_COMMON_ATUALIZA_OBSERVACAO:
      return {
        ...state,
        observacao: action.payload.observacao,
      };

    case actions.DESCARTE_COMMON_ATUALIZA_IMPRIMIR:
      return {
        ...state,
        imprimir: action.payload.imprimir,
      };

    default:
      return state;
  }
};

export default descarteCommonReducer;



// WEBPACK FOOTER //
// ./src/pages/descarte/common/store/descarte.reducer.js